import * as React from 'react';
import { Props as LayoutProps } from './BulletSectionLayout';
import { useMobile } from '../../../../utils/useMobile';

export type Props = {
	Layout: any;
	schema: any;
};

export const BulletSectionContainer = (props: Props) => {
	const isMobile = useMobile();
	const render = () => {
		const Layout = props.Layout;
		const outgoingProps: LayoutProps = {
			mobile: isMobile,
			schema: props.schema,
		};
		const returnValue = <Layout {...outgoingProps} />;
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
